import React, { useContext } from 'react'
import AddItem from '../addItem/AddItem'
import "./box.css";
import TodoContext from '../todoCtx/TdoCtx'

const Box = () => {

    const {isShown,setIsShown} = useContext(TodoContext);

    const showTasksHandler = ()=>{
        setIsShown(!isShown);
    }
  return (
    <div className='box'>
        <AddItem/>
        <button className='showButton' type="button" onClick={showTasksHandler}>Show Completed Tasks</button>
        </div>
  )
}

export default Box